import {
  Box,
  List,
  ListItem,
  Stack,
  Text,
  Spacer,
  Button,
} from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { routes } from 'src/lib/routes'
import { useEffect, useState } from 'react'
import SupportLoginCell from 'src/components/SupportLoginCell'
import { useHotkeys } from 'react-hotkeys-hook'
import hotkeys from 'src/lib/hotkeys'
import { gql } from '@apollo/client'

export const QUERY = gql`
  query SupportQuery($query: String) {
    peopleBy(query: $query) {
      id
      firstName
      lastName
      school {
        id
        name: schoolName
        subdomain
      }
    }
  }
`

export const Loading = () => <Box textAlign="center">Loading...</Box>

export const Empty = ({ query }) => {
  if (query === 'info@beehively.com') {
    return <Box textAlign="center">Please choose another email address</Box>
  } else if (query) {
    return <Box textAlign="center">No results</Box>
  }
  return <Box textAlign="center">Please enter email address</Box>
}

export const Failure = ({ error }) => <div>Error: {error.message}</div>

const PersonLine = ({ person, selected, loginAs }) => {
  const { firstName, lastName, school } = person
  const [login, setLogin] = useState(null)
  const navigate = useNavigate()
  const navigateToSchool = () => navigate(routes.school({ id: school.id }))

  useEffect(() => {
    if (loginAs) {
      setLogin(loginAs)
    }
  }, [loginAs])

  return (
    <ListItem
      isTruncated
      bg={selected ? 'gray.100' : 'white'}
      _hover={{
        borderColor: 'gray.200',
        bg: 'gray.50',
        cursor: 'pointer',
      }}
      padding={3}
      borderBottom="1px solid"
      borderColor="gray.100"
    >
      <Stack direction="row" spacing={3} align="center">
        <Stack spacing={1} onClick={navigateToSchool}>
          <Stack direction="row" spacing={2}>
            <Text fontWeight="600" color="gray.800">
              {firstName} {lastName}
            </Text>
            <Text fontSize="md" color="gray.500">
              {school.name}
            </Text>
          </Stack>
          <Text fontSize="xs" color="gray.500">
            {school.subdomain} &middot; {school.id}
          </Text>
        </Stack>
        <Spacer />
        {login ? (
          <SupportLoginCell
            id={school.id}
            name={school.name}
            personId={login === 'support' ? null : person.id}
          />
        ) : (
          <>
            <Button
              colorScheme="teal"
              size="xs"
              variant="ghost"
              onClick={() => setLogin(true)}
            >
              Login as {firstName}
              <Text display={!selected && 'none'}>
                &nbsp; [ {hotkeys.personLogin} ]
              </Text>
            </Button>
            <Button
              colorScheme="teal"
              size="xs"
              variant="ghost"
              onClick={() => setLogin('support')}
            >
              Login as Support
              <Text display={!selected && 'none'}>
                &nbsp;[ {hotkeys.login} ]
              </Text>
            </Button>
          </>
        )}
      </Stack>
    </ListItem>
  )
}

export const Success = ({ peopleBy }) => {
  const [active, setActive] = useState({ index: 0 })

  const people = peopleBy.filter((p) => p.school)

  const navigateList = (moveUp = false) => {
    let currentIndex = active.index
    if (moveUp) {
      setActive({ index: currentIndex > 0 ? currentIndex - 1 : 0 })
    } else {
      setActive({
        index: currentIndex < people.length - 1 ? currentIndex + 1 : 0,
      })
    }
  }

  useHotkeys(hotkeys.down, () => navigateList(), { enableOnTags: ['INPUT'] })
  useHotkeys(hotkeys.up, () => navigateList(true), { enableOnTags: ['INPUT'] })

  const handelLoginForSelected = (e, as) => {
    e.preventDefault()
    setActive({ ...active, login: as })
  }

  useHotkeys(hotkeys.personLogin, (e) => handelLoginForSelected(e, true), {
    enableOnTags: ['INPUT'],
  })

  useHotkeys(hotkeys.login, (e) => handelLoginForSelected(e, 'support'), {
    enableOnTags: ['INPUT'],
  })

  return (
    <List
      borderWidth={1}
      borderColor="gray.200"
      borderRadius="md"
      padding={2}
      bg="white"
      maxHeight="60vh"
      overflowY="auto"
      boxShadow="sm"
    >
      {people.map((person, idx) => (
        <PersonLine
          key={person.id}
          person={person}
          selected={idx == active.index}
          loginAs={idx == active.index ? active.login : null}
        />
      ))}
    </List>
  )
}
